import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import {
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import Typography from '@mui/material/Typography'
import dayjs from 'dayjs'
import { useUser } from '../../../../../hooks/useUser'
import { AllowShippingProviderLists } from '../../../../../utils/provider'
import {
  ImageLinks,
  LogoTypeProvider,
} from '../../../../../constants/image-link'

export interface IFilterMapped {
  page?: number
  perPage?: number
  startDate?: string
  endDate?: string
  view?: EViewType
  filter: Record<string, any>
  setFilter: any
}

interface FilterGroupProps {
  onDateNext: () => void
  onDatePrev: () => void
  onViewChange: (value: EViewType) => void
  date: string | Date
  view: EViewType
  filter: Record<string, any>
  setFilter: any
}

export enum EViewType {
  DAY = 'timeGridDay',
  WEEK = 'timeGridWeek',
  MONTH = 'dayGridMonth',
}

const menuItemsTypeView = [
  {
    label: 'เดือน',
    value: EViewType.MONTH,
  },
]

const CalendarFilter = ({
  date,
  view,
  onDateNext,
  onDatePrev,
  onViewChange,
  filter,
  setFilter,
}: FilterGroupProps) => {
  const { merchant } = useUser()

  let dateType = 'MMMM YYYY'

  if (view === EViewType.DAY) {
    dateType = 'DD MMMM YYYY'
  }

  return (
    <Grid
      container
      spacing={2}
      mb={2}
      alignItems={'center'}
      justifyContent={'space-between'}
    >
      <Grid item>
        <Typography variant={`h5`}>{dayjs(date).format(dateType)}</Typography>
      </Grid>
      <Grid item lg={6} xs={12}>
        <Grid
          container
          spacing={2}
          alignItems={'center'}
          justifyContent={'flex-end'}
        >
          <Grid item>
            <IconButton onClick={onDatePrev}>
              <KeyboardArrowLeftIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton onClick={onDateNext}>
              <KeyboardArrowRightIcon />
            </IconButton>
          </Grid>
          <Grid item lg={4}>
            <FormControl variant="filled" fullWidth>
              <InputLabel id="trackingProvider-label">
                ช่องทางการขนส่ง
              </InputLabel>
              <Select
                id="trackingProvider"
                name="trackingProvider"
                labelId="trackingProvider-label"
                value={filter.trackingProvider || ''}
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    trackingProvider: e.target.value,
                  })
                }
                fullWidth
              >
                <MenuItem value="all" key="all" selected>
                  ทั้งหมด
                </MenuItem>
                {AllowShippingProviderLists(merchant).map(
                  (item, index: number) => (
                    <MenuItem value={item.value} key={index}>
                      {item.value !== 'all' && (
                        <img
                          style={{ marginRight: 5 }}
                          src={
                            ImageLinks[
                              `LOGO_${item.value.toUpperCase()}` as LogoTypeProvider
                            ]
                          }
                          alt="smallLogoSocial"
                          height={20}
                        />
                      )}
                      {item.label}
                    </MenuItem>
                  ),
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CalendarFilter
